import qrCode from "qrcode";
import { NotificationManager } from "react-notifications";
import { Actions as COMPANY_ACTIONS } from "./companyActions";
import { Actions as PAYMENT_ACTIONS } from "../../store/actions/paymentActions";

import apiURL from "./apiURL";
import { createRequest } from "@/common/helpers/RequestHelpers";

// const apiURL = "http://localhost:3000"

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];
// types of action

const Types = {
	AUTHENTICATION_LOGIN: "AUTHENTICATION_LOGIN",
	AUTHENTICATION_SWITCH_COMPANY: "AUTHENTICATION_SWITCH_COMPANY",
	AUTHENTICATION_PROCESSING: "AUTHENTICATION_PROCESSING",
	AUTHENTICATION_LOGOUT: "AUTHENTICATION_LOGOUT",
	AUTHENTICATION_VALIDATE_CODE: "AUTHENTICATION_VALIDATE_CODE",
	AUTHENTICATION_RECOVERY_CODE_CHECK: "AUTHENTICATION_RECOVERY_CODE_CHECK",
	AUTHENTICATION_SETTING_PASSWORD: "AUTHENTICATION_SETTING_PASSWORD",
	AUTHENTICATION_SET_PASSWORD_RESULT: "AUTHENTICATION_SET_PASSWORD_RESULT",
	AUTHENTICATION_LOGIN_STATUS: "AUTHENTICATION_LOGIN_STATUS",
	AUTHENTICATION_ORGANISATIONS_LIST: "AUTHENTICATION_ORGANISATIONS_LIST",
	AUTHENTICATION_SET_MFA: "AUTHENTICATION_SET_MFA",
	AUTHENTICATION_MFA_VERIFIED: "AUTHENTICATION_MFA_VERIFIED",
	AUTHENTICATION_MFA_MODAL_STATUS: "AUTHENTICATION_MFA_MODAL_STATUS",
	AUTHENTICATION_SET_MFA_EXPIRY: "AUTHENTICATION_SET_MFA_EXPIRY",
	AUTHENTICATION_CREATING_DEMO: "AUTHENTICATION_CREATING_DEMO",
};

const settingsRequest = createRequest({
	urlPath: "/settings",
	// local: true,
});

const loggingIn = (saving) => ({
	type: Types.AUTHENTICATION_PROCESSING,
	saving,
});

const updateLoginStatus = (response, attempt) => ({
	type: Types.AUTHENTICATION_LOGIN,
	payload: response,
	attempt,
});

const setLogout = (response) => ({
	type: Types.AUTHENTICATION_LOGOUT,
	payload: response,
});

const companySwitched = ({ loading, response }) => ({
	type: Types.AUTHENTICATION_SWITCH_COMPANY,
	loading,
	payload: response,
});

const creatingDemo = (status) => ({
	type: Types.AUTHENTICATION_CREATING_DEMO,
	status,
});

const createDemoCompany = (country) => {
	return async (dispatch, getState) => {
		dispatch(creatingDemo(true));

		await fetch(apiURL + `/demo/create`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ jurisdiction: country }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(switchCompany(data.org));
			})
			.catch((error) => console.error(error));
		dispatch(creatingDemo());
		dispatch(getOrganisations());
	};
};

const switchCompany = (companyId, link) => {
	return async (dispatch, getState) => {
		const state = getState();

		if (companyId == state.company?.org) {
			return;
		}

    window.history.pushState(null,null,"/organisation/people")
		dispatch(companySwitched({ loading: true }));

		await new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve();
			}, 1000);
		});

		await fetch(apiURL + "/authentication/setCompany", {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ companyId }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// console.log('entity data',data)
				dispatch(COMPANY_ACTIONS.getCompanySettings(true, link ?? "/organisation/people"));
        dispatch(PAYMENT_ACTIONS.getBundles());
				dispatch(companySwitched({}));
			});
	};
};

const login = (username,password) => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(loggingIn(true))

    fetch(apiURL + '/authentication/login' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(updateLoginStatus(data,true))
    })
  }
}

const organisationsList = (data) => ({
  type: Types.AUTHENTICATION_ORGANISATIONS_LIST,
  payload: data
})

const getOrganisations = () => {
  return (dispatch, getState) => {

    const state = getState()
    settingsRequest({
      method: "GET",
      path: "/organisations",
    })
    .then(({data}) => {
      dispatch(organisationsList(data))
    }).catch(e=>{
      console.error(e)
    })
  }
}

const validatingCode = () => ({
  type: Types.AUTHENTICATION_VALIDATE_CODE,
});

const validatingCodeCheck = (response) => ({
  type: Types.AUTHENTICATION_RECOVERY_CODE_CHECK,
  payload: response,
});

const validateCode = () => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(validatingCode(true))

    const code = window.location.pathname.split('/')[3]

    fetch(apiURL + `/authentication/recovery-check/${code}` , {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(validatingCodeCheck(data))
    })
  }
}

const settingPassword = () => ({
  type: Types.AUTHENTICATION_SETTING_PASSWORD,
});

const setPasswordResult = (response) => ({
  type: Types.AUTHENTICATION_SET_PASSWORD_RESULT,
  payload: response,
});

const setPassword = (username,password,confirmPassword) => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(settingPassword(true))

    fetch(apiURL + `/authentication/reset` , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({
          code: window.location.pathname.split('/')[3],
          password
        }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(setPasswordResult(data))
    }).catch(err => {
      dispatch(setPasswordResult({error: "Unable to save your password"}))
      // console.log('err',err)
      // window.location.href = '/'
    })
  }
}


const resetPassword = (username) => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(loggingIn(true))

    fetch(apiURL + "/settings/reset-password" , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({username}),
        headers: {
           'Accept': 'application/json',
           'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      window.location.href = '/'
      console.log('resetPassword','resetPassword')
    }).catch(err => {
      window.location.href = '/'
    })
  }
}

const logout = () => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(loggingIn(true))

    fetch(apiURL + '/authentication/logout' , {
        credentials: 'include',
        method: 'POST',
        // body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(setLogout(data))
      window.location.href = window.location.origin
    })
  }
}

const setLoginStatus = (loginStatus) => ({
  type: Types.AUTHENTICATION_LOGIN_STATUS,
  loginStatus,
});

const isLoggedIn = () => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(loggingIn(true))

    fetch(apiURL + '/authentication/status' , {
        credentials: 'include',
        method: 'GET',
        // body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('entity data',data)
      dispatch(setLoginStatus(true))
      dispatch(updateLoginStatus(data,false))
    })
  }
}

const goToZendesk = (url) => {
  return (dispatch, getState) => {

    const state = getState()
    dispatch(loggingIn(true))

    fetch(apiURL + '/authentication/zendesk' , {
        credentials: 'include',
        method: 'GET',
        // body: JSON.stringify({username,password}),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          /*'Organisation': getState().currentOrganisation,*/
        },
    })
    .then(response => response.json())
    .then(data => {
      console.log('zendesktoken data',data)

      if (data.token){

        const currentParams =  new URLSearchParams(window.location.search.substring(1));

        const newParams =  new URLSearchParams();
        console.log('')
        newParams.set('jwt', data.token)
        newParams.set('return_to', url)

        window.location.href = `https://buddyhr.zendesk.com/access/jwt?${newParams.toString()}`
      }
    })
  }
}

const setMFA = (payload) => ({
  type: Types.AUTHENTICATION_SET_MFA,
  payload
});

const mfaVerified = (status) => ({
  type: Types.AUTHENTICATION_MFA_VERIFIED,
  status
});

const createQRCode = async (data) => {
  return new Promise(async (resolve, reject) => {
    const qr = await qrCode.toDataURL(data, {
      width: 1200,
      scale: 0.5,
      type: "image/png",
      margin: 0
    });
    if(qr) resolve(qr);
    else resolve(null);
  });
}

const initiateMFA = () => {
  return (dispatch, getState) => {

    const state = getState();

    fetch(apiURL + '/authentication/mfa/enable' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify?.({ email: state?.my?.profile?.email }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      if(data.url && data.secret) {
        createQRCode(data.url).then((qrData) => {
          if(qrData) dispatch(setMFA({...data, qrImg: qrData}));
          else console.error("Error occurred in QR Code generation!", data);
        });
      }
    })
  }
}

const setMfaExpiry = (expiry) => ({
  type: Types.AUTHENTICATION_SET_MFA_EXPIRY,
  expiry
});

const verifyMFA = (code) => {
  return (dispatch, getState) => {

    const state = getState();

    const { secret } = state?.my?.mfa?.setup;
    fetch(apiURL + '/authentication/mfa/verify' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ code, secret }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      dispatch(mfaVerified(!!data.verified));
      if(!data.error && data.success) {
        dispatch(setMFAModalStatus(false));
        dispatch(setMfaExpiry(data.mfaExpires));
        NotificationManager.success("MFA Verified Successfully!", "Success");
        dispatch(setMFA(null));
      } else {
        NotificationManager.error("Something went wrong!", "Error");
      }
    })
  }
}

const checkMFA = (code) => {
  return (dispatch, getState) => {

    fetch(apiURL + '/authentication/mfa/check' , {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify({ code }),
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
    })
    .then(response => response.json())
    .then(data => {
      if(data.success && data.verified) {
        dispatch(setMfaExpiry(data.mfaExpires));
        NotificationManager.success("Successfully Authenticated!", "Success");
      } else if(!data.error) {
        NotificationManager.error("Invalid MFA Code", "Error");
      } else {
        NotificationManager.error("An unknown error occurred", "Error");
      }
    })
  }
}

const setMFAModalStatus = (status) => ({
  type: Types.AUTHENTICATION_MFA_MODAL_STATUS,
  status
});

const Actions = {
  login,
  isLoggedIn,
  logout,
  resetPassword,
  setPassword,
  validateCode,
  getOrganisations,
  createDemoCompany,
  switchCompany,
  goToZendesk,
  initiateMFA,
  verifyMFA,
  checkMFA,
  setMFAModalStatus,
}

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions